/* any functionality that's shared between component variants but not needed by external components goes in this file */
import React from 'react';
import { FauxInputCheck, FauxInputContainer, Group, StyledSVG, radioCenterPoint, radioCheckRadius, radioContainerRadius } from './styles';
export var FauxInput = function FauxInput(_ref) {
  var size = _ref.size,
      customTheme = _ref.customTheme;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    "aria-hidden": true,
    role: "presentation",
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    size: size
  }, /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(FauxInputContainer, {
    as: "circle",
    cx: radioCenterPoint,
    cy: radioCenterPoint,
    r: radioContainerRadius,
    customTheme: customTheme
  }), /*#__PURE__*/React.createElement(FauxInputCheck, {
    as: "circle",
    cx: radioCenterPoint,
    cy: radioCenterPoint,
    r: radioCheckRadius,
    customTheme: customTheme
  })));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/radio/dist/esm/shared.js
// module id = 4057
// module chunks = 11